import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";
import { Box } from "@mui/material";
import { useAppSelector } from "store/hooks";
import { ModalSpinner } from "components/ModalSpinner";
import { ErrorDialog } from "components/ErrorDialog";
import { Login } from "components/Login";
import { customColors } from "models/customColors";
import { PasswordRecoveryPage } from "components/PasswordRecoveryPage";
import { SignUpVariants } from "components/SignUpVariants";
import { SignUpRecipient } from "components/SignUpRecipient";
import { SignUpSender } from "components/SignUpSender";
import { UnsubscribePage } from "components/UnsubscribePage";

const CommonLayout = () => {
  const spinner = useAppSelector((state) => state.spinner);
  
  return (
    <>
      <div className="flex flex-row h-screen">
        <Box
          flex={1}
          sx={{
            backgroundColor: customColors.lightGrayBackground,
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>
      </div>
      <ErrorDialog />
      <ModalSpinner open={spinner} />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <CommonLayout />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "/forgot",
        element: <PasswordRecoveryPage />,
      },
      {
        path: "/unsubscribe/:token",
        element: <UnsubscribePage />,
      },
      {
        path: "/login",
        element: <Navigate to={"/"} />,
      },
      {
        path: "/sign_up",
        element: <SignUpVariants />,
      },
      {
        path: "/sign_up/sender",
        element: <SignUpSender />,
      },
      {
        path: "/sign_up/recipient",
        element: <SignUpRecipient />,
      },
      {
        path: "*",
        element: <Login />,
      },
    ],
  },
]);

export const Auth = () => <RouterProvider router={router} />;
